/**
 * Enum for section names
 * @readonly
 * @enum {string}
 */
const SectionEnum = {
    PRE: 'pre',
    CART: 'cart',
    SHIPPING: 'shipping',
    PAYMENT: 'payment',
    ADROPTIONS: 'adrOptions',
    REVIEW: 'review'
};

export default SectionEnum;
